import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageService } from 'libs/core/src/lib/service/message.service';
import { MessageModel } from 'libs/core/src/lib/model/message.model';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  standalone: false
})
export class MessageComponent implements OnInit, AfterViewInit {
  public message$: Observable<MessageModel>;
  @Input() public custom: boolean;
  @Input() public cssStyle: boolean;
  @Input() public closeVisible = true;
  @Input() public autoClose = 0;

  @ViewChild('messageElement', { read: ElementRef, static: true })
  public el: ElementRef;

  timeout: any;

  constructor(protected messageService: MessageService) {}

  ngOnInit() {
    this.message$ = this.messageService.state$;
  }

  ngAfterViewInit(): void {
    this.message$.subscribe((value) => {
      if (this.el && value) {
        if (this.custom) {
          const targetElement = this.el.nativeElement;
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      }

      if (this.autoClose && value) {
        this.timeout = setTimeout(() => {
          this.onClose();
        }, this.autoClose * 1000);
      }
    });
  }

  onClose() {
    this.messageService.clear();

    if (this.autoClose) {
      clearTimeout(this.timeout);
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
}
